// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"a830b3ab","568":"d863a7a9","673":"f0a8352a","767":"81a4c9fb"}[chunkId] + ".chunk.js";
};